import { LiveCheckForm } from '../LiveCheckForm';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function LiveCheckPage() {
  usePageTopBar({});
  return <LiveCheckForm />;
}
